module.exports = __webpack_public_path__ + "img/eth-blocks.2e7fea76.svg";